import LOICard from "./loiCard"
export default LOICard